import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import Icon from '@icon/Icon';
import ButtonComponent from '@widget/buttons/ButtonComponent';
import Checkbox from '@widget/forms/inputs/Checkbox';
import { getWidgetIcon } from './widgetDrawerUtils';
import { hasValue } from '@utils';
/**
 * Minimal, clean tile component for widgets and UIs
 */
export const WidgetDrawerTile = forwardRef(({ item, type, isSelected, isMultiSelect, onSelect, status, onPreview, onRemove, context, addOns }, ref) => {
    // Get icon
    const icon = type === 'widget'
        ? getWidgetIcon(item, addOns)
        : item.icon || 'fal layer-group';
    // Get name and description
    const name = (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.label) || item.id;
    const description = hasValue(item.description)
        ? item.description
        : context.$L('uxp-core.text.no-description');
    /**
     * Render status badge
     */
    const renderBadge = () => {
        if (type !== 'widget' || !status)
            return null;
        const badgeClasses = classNames('uxpcore_widgetdrawer__tile-badge', {
            'uxpcore_widgetdrawer__tile-badge--added': status === 'added',
            'uxpcore_widgetdrawer__tile-badge--installed': status === 'installed',
            'uxpcore_widgetdrawer__tile-badge--not-installed': status === 'not-installed'
        });
        let label = '';
        if (status === 'added')
            label = context.$L('uxp-core.text.added');
        else if (status === 'installed')
            label = context.$L('uxp-core.text.installed');
        else if (status === 'not-installed')
            label = context.$L('uxp-core.text.not-installed');
        return _jsx("div", { className: badgeClasses, children: label });
    };
    /**
     * Render checkbox/indicator
     */
    const renderCheckbox = () => {
        if (!isMultiSelect)
            return null;
        return (_jsx("div", { className: "uxpcore_widgetdrawer__tile-checkbox", onClick: (e) => {
                e.stopPropagation();
                onSelect();
            }, children: _jsx(Checkbox, { checked: isSelected, onChange: () => { } }) }));
    };
    /**
     * Render action buttons
     */
    const renderActions = () => {
        const hasActions = onPreview || onRemove;
        if (!hasActions)
            return null;
        return (_jsxs("div", { className: "uxpcore_widgetdrawer__tile-actions", children: [onPreview && (_jsx(ButtonComponent, { leftIcon: "fal eye", iconOnly: true, onClick: (e) => {
                        e.stopPropagation();
                        onPreview();
                    }, variant: "secondary", title: context.$L('uxp-core.text.widget-preview') })), onRemove && (_jsx(ButtonComponent, { leftIcon: "fal trash", iconOnly: true, onClick: (e) => {
                        e.stopPropagation();
                        onRemove();
                    }, variant: "danger", title: context.$L('uxp-core.text.trash') }))] }));
    };
    return (_jsxs("div", { ref: ref, className: classNames('uxpcore_widgetdrawer__tile', {
            'uxpcore_widgetdrawer__tile--selected': isSelected
        }), onClick: onSelect, children: [_jsxs("div", { className: "uxpcore_widgetdrawer__tile-icon-wrapper", children: [renderCheckbox(), _jsx(Icon, { icon: icon, className: "uxpcore_widgetdrawer__tile-icon" })] }), _jsxs("div", { className: "uxpcore_widgetdrawer__tile-content", children: [renderBadge(), _jsx("div", { className: "uxpcore_widgetdrawer__tile-title line-clamp line-clamp-1", children: context.$L(name) }), _jsx("div", { className: "uxpcore_widgetdrawer__tile-description line-clamp line-clamp-2", children: context.$L(description) })] }), renderActions()] }));
});
WidgetDrawerTile.displayName = 'WidgetDrawerTile';
export default WidgetDrawerTile;
